module.exports = __webpack_public_path__ + "692c400e591cd1ce055b86e0e021bec1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-30.png
// module id = 3293
// module chunks = 0